import React, { useState, useEffect } from "react";
import DrEvent from "../../display/DrEvent";

/*
    Display target price and your price
    button that say hold


*/

function GasChallenge(props) {
  const [capturingTime, setCapturingTime] = useState(false);
  const [myTotal, setMyTotal] = useState(0.0);
  const [showButton, setShowButton] = useState(true);
  let timer;
  useEffect(() => {
    if (capturingTime) {
      timer = setInterval(() => {
        setMyTotal((myTotal) => parseFloat((myTotal + 0.12).toFixed(2)));
      }, 50);
    } else {
      return () => clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [capturingTime]);

  function handleHoldStart() {
    if (myTotal === 0.0) {
      setCapturingTime(true);
    }
  }

  useEffect(() => {
    if (myTotal > 20) {
      setCapturingTime(false);
      handleHoldEnd();
    }
  }, [myTotal]);

  function handleHoldEnd() {
    setCapturingTime(false);

    const res = myTotal === 0 ? 0.01 : myTotal;

    let payload = {};
    setShowButton(false);
    let timeout = setTimeout(() => {
      payload["userInput"] = res;
      payload["type"] = "input submitted";
      payload["valLabel"] = "$";
      payload["displayType"] = "DESC";
      props.sendEvent("input submitted", payload);
      props.handleNextBtn();
    }, 2000);
    return () => clearTimeout(timeout);
  }

  function renderPump() {
    return (
      <>
        <div className="pumpText">{"$\t\t15.00"}</div>
        <div className={`pumpText playerTotal ${myTotal > 15 ? "over" : ""}`}>
          ${"\t\t"}
          {`${myTotal.toFixed(2).split(".")[0].padStart(2, "0")}.${
            myTotal.toFixed(2).split(".")[1]
          }`}
        </div>
      </>
    );
  }

  function renderButton() {
    if (showButton) {
      return (
        <button
          onMouseDown={handleHoldStart}
          onMouseUp={handleHoldEnd}
          onTouchStart={handleHoldStart}
          onTouchEnd={handleHoldEnd}
          className="pumpButton"
        >
          {"Hold Until\nTotals Match"}
        </button>
      );
    } else {
      return <></>;
    }
  }

  return (
    <DrEvent
      className="challengeContainer"
      style={{ transform: props.flipped ? "rotateY(180deg)" : "" }}
    >
      <>
        {renderPump()}
        {renderButton()}
      </>
    </DrEvent>
  );
}

export default GasChallenge;
